import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getYearsEnrolled, isEligibleToAcceptOffer } from '../../helpers/enrolment'
import { fetchUnitsIfNeeded } from '../../actions/units'
import { fetchPersonalDataIfNeeded } from '../../actions/personalDetails'
import { fetchCourses } from '../../actions/courses'
import EnrolmentsContainer from '../tags/EnrolmentsContainer'

const mapStateToProps = ({ courses: { selectedCourseCode, data, isFetchingCourses }, course: { selectedCourse, isFetchingCourse }, units, personalDetails, currentUser, enrolmentContainer: {pageToDisplay} }) => {
  return {
    courseId: selectedCourseCode,
    courseAttemptStatus: selectedCourse.courseAttemptStatus,
    course: selectedCourse,
    parentSSPNo: selectedCourse.parentSSPNo,
    units: units[selectedCourseCode].items,
    personalDetails: personalDetails.data,
    isFetchingCourses: isFetchingCourses,
    loadingUnits: units[selectedCourseCode].receivedAt === null || units[selectedCourseCode].isFetching,
    enrolmentYears: units[selectedCourseCode].items.length > 0 ? getYearsEnrolled(units[selectedCourseCode].items) : [],
    loadingPersonalDetails: personalDetails.isFetchingPersonalDetails,
    userRole: currentUser.data['role'],
    //pageContentsToDisplay: units[selectedCourseCode].items.length > 0 ? getYearsEnrolled(units[selectedCourseCode].items)[0] : "NOW"
    pageContentsToDisplay: pageToDisplay
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUnits: (courseId, parentSSPNo) => {
      dispatch(fetchUnitsIfNeeded(courseId, parentSSPNo))
    },
    fetchPersonalDetails: () => {
      dispatch(fetchPersonalDataIfNeeded())
    },
    fetchCourses: () => {
      dispatch(fetchCourses())
    }
  }
}

class Enrolments extends Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
      if (this.props.userRole == 'STUDENT') {
        this.props.fetchUnits(this.props.courseId, this.props.parentSSPNo)
        this.props.fetchPersonalDetails()
      }
    }
  
    componentDidUpdate(prevProps, prevState) {
  
      if (this.props.userRole === 'STUDENT') {
        if (prevProps.courseId !== this.props.courseId) {
          this.props.fetchUnits(this.props.courseId, this.props.parentSSPNo)
        }
  
        if (!this.props.loadingUnits && this.props.units.length > 0 && isEligibleToAcceptOffer(this.props.course)) {
          sessionStorage.removeItem('COURSES')
          this.props.fetchCourses()
        }
      }
    }

  render() {
    return (
      <div>
        <EnrolmentsContainer
          courseId={this.props.courseId}
          courseAttemptStatus={this.props.courseAttemptStatus}
          course={this.props.course}
          parentSSPNo={this.props.parentSSPNo}
          units={this.props.units}
          personalDetails={this.props.personalDetails}
          isFetchingCourses={this.props.isFetchingCourses}
          loadingUnits={this.props.loadingUnits}
          enrolmentYears={this.props.enrolmentYears}
          loadingPersonalDetails={this.props.loadingPersonalDetails}
          userRole={this.props.userRole}
          pageContentsToDisplay={this.props.pageContentsToDisplay}        
        ></EnrolmentsContainer>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Enrolments)
